/**
 * Global saat dilimi yaması — tüm uygulamada tarih/saat gösterimini
 * Türkiye saatine (Europe/Istanbul) sabitler.
 *
 * Backend zaman damgaları UTC olarak saklanır. Tarayıcının saat dilimi
 * (örn. sunucu konteynerinde UTC) ne olursa olsun, toLocale* metotları
 * artık varsayılan olarak Europe/Istanbul saatini kullanır.
 *
 * timeZone seçeneği zaten verilmişse dokunulmaz.
 */
const TR_TZ = 'Europe/Istanbul';

const withTZ = (options) => {
  if (options && options.timeZone) return options;
  return { ...(options || {}), timeZone: TR_TZ };
};

['toLocaleString', 'toLocaleDateString', 'toLocaleTimeString'].forEach((fn) => {
  const original = Date.prototype[fn];
  Date.prototype[fn] = function (locales, options) {
    return original.call(this, locales, withTZ(options));
  };
});
